import * as React from 'react';

var _path$Z;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    d: "M6.496 3.996v2.572m5.572.428a5.571 5.571 0 1 1-11.143 0 5.571 5.571 0 0 1 11.143 0ZM6.925 9.14a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$Y;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    d: "M10.384 8.223v4.285m.715 4.286a.714.714 0 1 1-1.429 0 .714.714 0 0 1 1.429 0Zm.557-14.214a1.428 1.428 0 0 0-2.543 0L1.256 18.294a1.429 1.429 0 0 0 1.271 2.072h15.715a1.43 1.43 0 0 0 1.271-2.072L11.656 2.58Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$X;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    d: "M16.429 8H1.57m0 0 4-4m-4 4 4 4",
    stroke: "#000",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$W;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var SvgBellAlert = function SvgBellAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.568 1.092a.7.7 0 0 1-.16.977A5.3 5.3 0 0 0 2.2 6.37.7.7 0 1 1 .8 6.37 6.7 6.7 0 0 1 3.59.932a.7.7 0 0 1 .977.16Zm6.863 0a.7.7 0 0 1 .977-.16A6.7 6.7 0 0 1 15.2 6.37a.7.7 0 0 1-1.4 0A5.3 5.3 0 0 0 11.59 2.07a.7.7 0 0 1-.16-.977ZM4.676 3.177A4.7 4.7 0 0 1 12.7 6.5V10a.8.8 0 0 0 .8.8.7.7 0 1 1 0 1.4h-11a.7.7 0 0 1 0-1.4.8.8 0 0 0 .8-.8V6.5a4.7 4.7 0 0 1 1.376-3.323ZM4.55 10.8h6.901a2.2 2.2 0 0 1-.15-.8V6.5a3.3 3.3 0 0 0-6.6 0V10a2.2 2.2 0 0 1-.15.8ZM6.3 14a.7.7 0 0 1 .7-.7h2a.7.7 0 1 1 0 1.4H7a.7.7 0 0 1-.7-.7Z",
    fill: "currentColor"
  })));
};

var _path$V;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var SvgBulletList = function SvgBulletList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    d: "M4.857 2.143h7.715M4.857 6h7.715M4.857 9.857h7.715M2.286 2.143a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0Zm0 3.857a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0Zm0 3.857a.429.429 0 1 1-.857 0 .429.429 0 0 1 .857 0Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$U;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "M2.714 3.286a1.143 1.143 0 0 0-1.143 1.143v10.857a1.143 1.143 0 0 0 1.143 1.143h12.572a1.143 1.143 0 0 0 1.142-1.143V4.429a1.143 1.143 0 0 0-1.142-1.143H13m-11.429 4h14.857M5 1.57V5m8-3.429V5M5 3.286h5.714",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$T;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    d: "M3.743 14.257 14.257 3.743m0 10.514L3.743 3.743M16.428 9A7.429 7.429 0 1 1 1.571 9a7.429 7.429 0 0 1 14.857 0Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$S;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgChair = function SvgChair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 9.04V4.667a3 3 0 0 0-6 0V9.04m3 2.627v5m-4.36 0a4.44 4.44 0 0 1 4.36-3 4.447 4.447 0 0 1 4.36 3M2.667 7.333v2.334a2 2 0 0 0 2 2h1m-4-4.334h2m11 0v2.334a2 2 0 0 1-2 2h-1m4-4.334h-2m-1 3a1.333 1.333 0 0 1-1.333 1.334H6A1.333 1.333 0 1 1 6 9h5.333a1.333 1.333 0 0 1 1.333 1.333Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _g, _defs;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgChampagneIcon = function SvgChampagneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#champagne-icon_svg__a)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.877 12.557 3.212.98M2.483 13.047l.982-3.22M4.862 9.83a2.327 2.327 0 0 1-2.51-.766 2.425 2.425 0 0 1-.326-2.49L4.478.698a.422.422 0 0 1 .511-.243l2.487.756a.423.423 0 0 1 .287.49L6.521 7.945A2.427 2.427 0 0 1 4.86 9.83ZM3.323 3.466l3.855 1.176",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15 5.71a.218.218 0 0 1 0-.437M4.15 5.71a.218.218 0 0 0 0-.437M3.713 8.327a.218.218 0 1 1 0-.436M3.713 8.327a.218.218 0 1 0 0-.436M5.032 7.02a.218.218 0 1 1 0-.436M5.032 7.02a.218.218 0 1 0 0-.436M8.949 5.71a.218.218 0 0 1 0-.437M8.949 5.71a.218.218 0 0 0 0-.437M10.258 7.02a.218.218 0 1 1 0-.436M10.258 7.02a.218.218 0 1 0 0-.436M9.385 8.327a.218.218 0 0 1 0-.436M9.385 8.327a.218.218 0 1 0 0-.436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.906 13.563 3.217-.964M11.514 13.08l-.966-3.224M8.781.563l.335-.1a.422.422 0 0 1 .51.248l2.423 5.886a2.426 2.426 0 0 1-.337 2.488 2.331 2.331 0 0 1-2.514.756 2.41 2.41 0 0 1-1.346-1.073M9.214 3.948l1.553-.465",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "champagne-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};

var _path$R;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    d: "m4.429 7.857 1.757 1.406a.411.411 0 0 0 .343.086.429.429 0 0 0 .291-.206l2.752-4.714m3 2.571A5.571 5.571 0 1 1 1.429 7a5.571 5.571 0 0 1 11.143 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$Q;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "m2.714 14.214 3.9 5.015a1.428 1.428 0 0 0 2.229.042L21.286 4.214",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$P;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "m1.252 1 4.415 3.904a.384.384 0 0 0 .503 0L10.585 1",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$O;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    d: "m15 5-5.856 6.623a.522.522 0 0 0-.106.172.576.576 0 0 0 0 .41.522.522 0 0 0 .106.172L15 19",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$N;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    d: "m9 5 5.856 6.623a.52.52 0 0 1 .106.172.577.577 0 0 1 0 .41.52.52 0 0 1-.106.172L9 19",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$M;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgClockCircleReturn = function SvgClockCircleReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    d: "M1.571 9A7.429 7.429 0 1 0 9 1.57a8.263 8.263 0 0 0-5.714 2.286m0 0 .571-2.286m-.571 2.286 2.285.571M9 5V9.57l-2.971 1.486",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$L;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgClockCircle = function SvgClockCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.643V8.5l2.903 3.383M15.429 8.5a7.429 7.429 0 1 1-14.857 0 7.429 7.429 0 0 1 14.857 0Z",
    stroke: "currentColor",
    strokeWidth: 1.095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$K;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgCloseOutlined = function SvgCloseOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M14.029 7.971 7.97 14.03m0-6.058 6.058 6.058M20.286 11a9.286 9.286 0 1 1-18.571 0 9.286 9.286 0 0 1 18.57 0Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$J;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    d: "m10.643 1.357-9.286 9.286m0-9.286 9.286 9.286",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$I;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgCsvDownload = function SvgCsvDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5h-3a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3m-8-5v12m4-12v6m4-2h-12m6 4h-6m11 1v4m0 0L11 13m1.5 1.5L14 13m-5.5-.5a4 4 0 1 0 8 0 4 4 0 0 0-8 0Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$H;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M15.464 13.464a.75.75 0 0 0-1.5 0h1.5Zm-13.751.859-.53.53.53-.53Zm0-12.646-.53-.53.53.53Zm12.646 0 .53-.53-.53.53Zm-.395.859a.75.75 0 0 0 1.5 0h-1.5ZM8.036 7.25a.75.75 0 0 0 0 1.5v-1.5Zm9.107.75.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-1.898-2.959a.75.75 0 0 0-1.061 1.06l1.06-1.06Zm-1.061 4.857a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm-.22 3.566a.464.464 0 0 1-.136.329l1.061 1.06c.368-.368.575-.868.575-1.389h-1.5Zm-.136.329a.465.465 0 0 1-.328.136v1.5c.521 0 1.02-.207 1.389-.576l-1.06-1.06Zm-.328.136H2.571v1.5H13.5v-1.5Zm-10.929 0a.465.465 0 0 1-.328-.136l-1.06 1.06c.368.369.867.576 1.388.576v-1.5Zm-.328-.136a.464.464 0 0 1-.136-.329h-1.5c0 .521.207 1.02.576 1.39l1.06-1.061Zm-.136-.329V2.536h-1.5v10.928h1.5Zm0-10.928c0-.123.05-.242.136-.329l-1.06-1.06a1.964 1.964 0 0 0-.576 1.389h1.5Zm.136-.329a.464.464 0 0 1 .328-.136v-1.5c-.52 0-1.02.207-1.388.576l1.06 1.06Zm.328-.136H13.5v-1.5H2.571v1.5Zm10.929 0c.123 0 .241.05.328.136l1.061-1.06A1.964 1.964 0 0 0 13.5.57v1.5Zm.328.136a.465.465 0 0 1 .136.329h1.5c0-.521-.207-1.02-.575-1.39l-1.06 1.061ZM8.036 8.75h9.107v-1.5H8.036v1.5Zm6.148-2.648 2.429 2.428 1.06-1.06-2.428-2.429-1.061 1.06Zm2.429 1.368-2.429 2.428 1.06 1.06 2.43-2.428-1.061-1.06Z",
    fill: "currentColor"
  })));
};

var _path$G, _path2$6;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6h1a.5.5 0 0 1 .5.5V14a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 2 14V6.5a.5.5 0 0 1 .5-.5h1",
    stroke: "#292929",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5v-7M5 3.5l2-2 2 2",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$F;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M8.572 1.572H2.857a1.143 1.143 0 0 0-1.143 1.142v12.572a1.143 1.143 0 0 0 1.143 1.143h10.286a1.143 1.143 0 0 0 1.143-1.143v-8M8.572 1.572l5.714 5.714M8.572 1.572v5.714h5.714",
    stroke: "currentColor",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$E;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M16.428 1.571H1.571l5.715 8v6.858l3.428-2.286V9.57l5.714-8Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$D;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgFriendship = function SvgFriendship(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    d: "m8.51 14.98-.663 5.306h-3.98l-.663-5.306H1.878a.663.663 0 0 1-.664-.664V12.99a4.643 4.643 0 0 1 4.643-4.643h9.286a4.643 4.643 0 0 1 4.643 4.643v1.326a.663.663 0 0 1-.664.664h-1.326l-.663 5.306h-3.98l-.663-5.306M5.857 6.357a2.321 2.321 0 1 0 0-4.643 2.321 2.321 0 0 0 0 4.643Zm9.286 0a2.321 2.321 0 1 0 0-4.643 2.321 2.321 0 0 0 0 4.643Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$C;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgGridView = function SvgGridView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M6.143 1.571H2.714c-.631 0-1.143.512-1.143 1.143v3.429c0 .63.512 1.143 1.143 1.143h3.429c.63 0 1.143-.512 1.143-1.143V2.714c0-.631-.512-1.143-1.143-1.143ZM15.286 1.571h-3.429c-.631 0-1.143.512-1.143 1.143v3.429c0 .63.512 1.143 1.143 1.143h3.429c.63 0 1.142-.512 1.142-1.143V2.714c0-.631-.511-1.143-1.142-1.143ZM6.143 10.714H2.714c-.631 0-1.143.512-1.143 1.143v3.429c0 .63.512 1.142 1.143 1.142h3.429c.63 0 1.143-.511 1.143-1.142v-3.429c0-.631-.512-1.143-1.143-1.143ZM15.286 10.714h-3.429c-.631 0-1.143.512-1.143 1.143v3.429c0 .63.512 1.142 1.143 1.142h3.429c.63 0 1.142-.511 1.142-1.142v-3.429c0-.631-.511-1.143-1.142-1.143Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$B;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 7.429a2.857 2.857 0 0 0 0-5.715m2.857 13.715h2.285v-.62a5.155 5.155 0 0 0-4-4.97M6.714 7.43a2.857 2.857 0 1 0 0-5.715 2.857 2.857 0 0 0 0 5.715Zm-5.143 8v-.62a5.155 5.155 0 0 1 5.376-5.095 5.154 5.154 0 0 1 4.91 5.095v.62H1.571Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$A;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 18,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    d: "M1.572 9.714 9 2.286l7.429 7.428M3.857 7.43v8h10.286v-8m-5.143 8V12m1.429-4.286a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0Z",
    stroke: "#292929",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$z, _path2$5, _path3$1;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgInfoFilled = function SvgInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM5.5 10h3-3Z",
    fill: "currentColor"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7 10V6.5H6",
    fill: "currentColor"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10h3M7 10V6.5H6m1 7a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0-9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$y, _path2$4;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M9.571 9.369a.917.917 0 0 0 0 1.833h.512v3.167H8.857a.917.917 0 0 0 0 1.833h4.286a.917.917 0 1 0 0-1.833h-1.226v-4.083A.917.917 0 0 0 11 9.369H9.571ZM11.042 8.333a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z",
    fill: "currentColor"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 .798C5.365.798.798 5.365.798 11S5.365 21.202 11 21.202 21.202 16.635 21.202 11 16.635.798 11 .798ZM2.63 11a8.37 8.37 0 1 1 16.739 0 8.37 8.37 0 0 1-16.738 0Z",
    fill: "currentColor"
  })));
};

var _path$x;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.298 1.298A1.7 1.7 0 0 1 2.5.8h7a.7.7 0 0 1 .495.205l5 5a.7.7 0 0 1 .205.495v7a1.7 1.7 0 0 1-1.7 1.7h-11a1.7 1.7 0 0 1-1.7-1.7v-11c0-.451.179-.883.498-1.202ZM2.5 2.2a.3.3 0 0 0-.3.3v11a.3.3 0 0 0 .3.3h11a.3.3 0 0 0 .3-.3V7.2H10A1.2 1.2 0 0 1 8.8 6V2.2H2.5Zm7.7.99 2.61 2.61H10.2V3.19Zm-4.7.11a.7.7 0 0 1 .7.7v.877c.264.06.515.159.737.3.425.27.763.722.763 1.323a.7.7 0 1 1-1.4 0v-.001c0-.02 0-.068-.115-.141-.13-.084-.366-.158-.685-.158-.215 0-.38 0-.524.013a.796.796 0 0 0-.244.048H4.73a.66.66 0 0 0-.03.239c0 .098.033.2.217.353.206.172.501.323.896.52l.034.018c.35.175.788.393 1.132.68.38.316.72.777.72 1.429 0 .322-.052.635-.2.91-.156.29-.388.482-.645.6-.22.102-.452.145-.654.166V12a.7.7 0 1 1-1.4 0v-.86a2.258 2.258 0 0 1-.71-.252c-.482-.278-.79-.755-.79-1.388a.7.7 0 0 1 1.4 0c0 .08.017.11.02.118.006.008.02.029.068.056.115.067.346.126.712.126.215 0 .38 0 .524-.013a.796.796 0 0 0 .245-.049.66.66 0 0 0 .03-.238c0-.099-.033-.2-.216-.353-.207-.172-.501-.324-.896-.521l-.035-.017c-.35-.175-.787-.394-1.132-.68-.379-.317-.72-.778-.72-1.43 0-.322.053-.634.201-.91.156-.288.387-.481.645-.6.22-.102.451-.145.654-.166V4a.7.7 0 0 1 .7-.7Zm4 7.9a.7.7 0 1 1 0-1.4h3a.7.7 0 1 1 0 1.4h-3Z",
    fill: "currentColor"
  })));
};

var _path$w;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgLocationCompany = function SvgLocationCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M8.992 15.204V7.115m-7.36 8.09V4.588a.98.98 0 0 1 .98-.98h4.431M3.966 6.222H6.66m-2.694 2.84H6.66m-2.694 6.035v-3.246H6.66v3.246m-6.089.108h9.483m5.374-11.63c0 1.466-2.779 5.002-2.779 5.002S9.87 5.041 9.87 3.575c0-1.467 1.258-2.78 2.78-2.78a2.795 2.795 0 0 1 2.78 2.78Zm-2.779.345a.311.311 0 1 1 0-.622.311.311 0 0 1 0 .622Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$v, _path2$3;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    d: "M13.143 5.714C13.143 8.56 8 15.43 8 15.43S2.857 8.56 2.857 5.714a5.143 5.143 0 0 1 10.286 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.429A1.714 1.714 0 1 0 8 4a1.714 1.714 0 0 0 0 3.429Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$u;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgMailFlash = function SvgMailFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "m5.143 5.677 5.143 3.394 5.142-3.394M.571 4.5h1.715M.57 7.929h1.715M.57 11.357h1.715m4-6.857h8c.63 0 1.142.512 1.142 1.143v5.714c0 .631-.511 1.143-1.142 1.143h-8a1.143 1.143 0 0 1-1.143-1.143V5.643c0-.631.511-1.143 1.143-1.143Z",
    stroke: "currentColor",
    strokeWidth: 1.095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$t;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgMailSendEnvelope = function SvgMailSendEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "m1.214 4.286 8.371 7.143a1.429 1.429 0 0 0 1.829 0l8.371-7.143M2.642 2.5h15.715c.789 0 1.428.64 1.428 1.429V16.07c0 .79-.64 1.429-1.428 1.429H2.642c-.789 0-1.428-.64-1.428-1.429V3.93c0-.79.64-1.429 1.428-1.429Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$s, _path2$2;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgMapLocationStar = function SvgMapLocationStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M16.429 4.253c0 1.41-2.675 4.814-2.675 4.814S11.08 5.664 11.08 4.253s1.209-2.675 2.674-2.675a2.69 2.69 0 0 1 2.675 2.675Z",
    stroke: "#292929",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.754 4.466a.3.3 0 0 1 0-.599M13.754 4.466a.3.3 0 1 0 0-.599M6.822 6.435l1.623 3.287 3.628.527-2.626 2.56.62 3.613-3.245-1.706-3.245 1.706.62-3.614-2.625-2.559L5.2 9.722l1.622-3.287Z",
    stroke: "#292929",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$r;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "m6.52 15.286-3.548.82a1.143 1.143 0 0 1-1.4-1.114V3.623c0-.532.367-.994.885-1.113L6.52 1.57m0 13.715V1.57m0 13.715 4.96 1.143M6.52 1.57l4.96 1.143m0 13.715V2.714m0 13.715 4.063-.939c.518-.12.886-.581.886-1.113V3.008c0-.735-.684-1.279-1.4-1.113l-3.549.82",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$q;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    viewBox: "0 0 10 1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M1.429.5h11.143",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$p;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgMoneyCircle = function SvgMoneyCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.2a5.8 5.8 0 1 0 0 11.6A5.8 5.8 0 0 0 8 2.2ZM.8 8a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 .8 8ZM8 3.3a.7.7 0 0 1 .7.7v.877c.264.06.515.16.737.3.425.27.763.722.763 1.323a.7.7 0 1 1-1.4 0v-.001c0-.02 0-.068-.115-.14C8.555 6.274 8.32 6.2 8 6.2c-.215 0-.38 0-.524.013a.796.796 0 0 0-.246.048.66.66 0 0 0-.03.239c0 .098.033.2.217.353.206.172.501.323.896.52.011.007.023.012.034.018.35.175.788.393 1.132.68.38.317.72.777.72 1.429 0 .322-.052.635-.2.91-.156.29-.388.482-.645.6-.22.103-.452.146-.654.167V12a.7.7 0 1 1-1.4 0v-.86a2.26 2.26 0 0 1-.71-.252c-.482-.277-.79-.755-.79-1.388a.7.7 0 0 1 1.4 0c0 .08.017.11.02.118.006.008.02.029.068.057.115.066.346.125.712.125.215 0 .38 0 .524-.013a.796.796 0 0 0 .245-.048.66.66 0 0 0 .03-.239c0-.098-.033-.2-.216-.353-.207-.172-.501-.324-.896-.52l-.035-.018c-.35-.175-.787-.393-1.132-.68-.379-.317-.72-.777-.72-1.429 0-.322.053-.635.201-.91.156-.29.387-.482.645-.6.22-.103.451-.146.654-.167V4a.7.7 0 0 1 .7-.7Z",
    fill: "currentColor"
  })));
};

var _path$o;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgMoneyNote = function SvgMoneyNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    d: "M3.572 3.286H4m6 3.428h.429M2.286 1.143h9.428c.474 0 .858.384.858.857v6a.857.857 0 0 1-.858.857H2.286A.857.857 0 0 1 1.429 8V2c0-.473.383-.857.857-.857Zm6 3.857a1.286 1.286 0 1 1-2.572 0 1.286 1.286 0 0 1 2.572 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$n;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.002h-13m13-4h-13m13-4h-13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$m;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgPencilEditor = function SvgPencilEditor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.715 2.354a.145.145 0 0 0-.104.044l-.008.008-8.08 8.041-.79 2.82 2.82-.79 8.041-8.08.004-.004a.146.146 0 0 0 0-.206l-.004-.004-1.77-1.78-.005-.005a.145.145 0 0 0-.104-.044ZM10.995.79a1.854 1.854 0 0 1 2.043.41l1.767 1.776a1.856 1.856 0 0 1 0 2.63l-8.199 8.238a.855.855 0 0 1-.375.22l-4.5 1.26A.855.855 0 0 1 .677 14.27l1.26-4.5a.855.855 0 0 1 .22-.375l8.236-8.197c.172-.174.377-.313.603-.408Z",
    fill: "currentColor"
  })));
};

var _path$l;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.617v14.857M1.57 9h14.857",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$k;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M8 .571v.5-.5ZM1.817 12.114l.468.176a.5.5 0 0 0-.051-.453l-.417.277ZM.572 15.428l-.468-.176a.5.5 0 0 0 .557.668l-.09-.492Zm4.171-.754.22-.45a.5.5 0 0 0-.309-.042l.089.492Zm1.043-8.388a.5.5 0 0 0 1 0h-1ZM8 8v-.5a.5.5 0 0 0-.5.5H8Zm-.5 1.143a.5.5 0 0 0 1 0h-1Zm.5 1.714.007-.5H8v.5Zm.857.857h.5v-.006l-.5.006ZM8 .071c-1.434 0-2.841.39-4.072 1.127l.514.858A6.929 6.929 0 0 1 8 1.071v-1ZM3.928 1.198a7.929 7.929 0 0 0-2.915 3.058l.882.472a6.929 6.929 0 0 1 2.547-2.672l-.514-.858ZM1.013 4.256a7.929 7.929 0 0 0-.93 4.121l.999-.047a6.928 6.928 0 0 1 .813-3.602l-.882-.472Zm-.93 4.121A7.929 7.929 0 0 0 1.4 12.391l.833-.554A6.928 6.928 0 0 1 1.082 8.33l-1 .047Zm1.266 3.561L.104 15.252l.936.352 1.245-3.314-.936-.352ZM.661 15.92l4.17-.754-.177-.984-4.171.754.178.985Zm3.862-.797a7.928 7.928 0 0 0 3.442.805l.005-1a6.928 6.928 0 0 1-3.008-.703l-.439.898Zm3.442.805a7.928 7.928 0 0 0 3.45-.77l-.43-.903a6.927 6.927 0 0 1-3.015.673l-.005 1Zm3.45-.77a7.928 7.928 0 0 0 2.772-2.194l-.78-.626a6.93 6.93 0 0 1-2.422 1.917l.43.902Zm2.772-2.194a7.928 7.928 0 0 0 1.543-3.18l-.975-.225a6.93 6.93 0 0 1-1.348 2.779l.78.626Zm1.543-3.18a7.928 7.928 0 0 0 .007-3.535l-.975.221a6.93 6.93 0 0 1-.007 3.089l.975.225Zm.007-3.535a7.928 7.928 0 0 0-1.529-3.186l-.782.622a6.929 6.929 0 0 1 1.336 2.785l.975-.22Zm-1.529-3.186A7.928 7.928 0 0 0 11.446.857l-.434.901a6.93 6.93 0 0 1 2.414 1.927l.782-.622ZM11.446.857A7.929 7.929 0 0 0 8 .071v1c1.043 0 2.073.234 3.012.687l.434-.9Zm-4.66 5.429c0-.24.071-.475.204-.675l-.831-.556a2.214 2.214 0 0 0-.373 1.23h1Zm.204-.675c.134-.2.324-.355.545-.447l-.382-.924c-.405.167-.75.451-.994.815l.831.556Zm.545-.447c.222-.092.466-.116.702-.07l.195-.98a2.214 2.214 0 0 0-1.28.126l.383.924Zm.702-.07c.236.047.452.163.622.333l.707-.707c-.31-.31-.704-.52-1.134-.606l-.195.98Zm.622.333c.17.17.285.386.332.622l.98-.195a2.214 2.214 0 0 0-.605-1.134l-.707.707Zm.332.622c.047.235.023.48-.069.701l.924.383c.167-.405.211-.85.126-1.28l-.98.196Zm-.069.701a1.214 1.214 0 0 1-.447.545l.555.832c.364-.244.648-.59.816-.994l-.924-.383Zm-.447.545c-.2.134-.435.205-.675.205v1c.438 0 .866-.13 1.23-.373l-.555-.832ZM7.5 8v1.143h1V8h-1Zm.5 2.357c-.268 0-.53.08-.754.229l.556.831a.357.357 0 0 1 .198-.06v-1Zm-.754.229c-.223.149-.397.36-.5.609l.924.383a.357.357 0 0 1 .132-.16l-.556-.832Zm-.5.609c-.102.248-.13.52-.077.784l.98-.195a.357.357 0 0 1 .021-.207l-.924-.382Zm-.077.784c.052.263.182.505.371.695l.708-.707a.357.357 0 0 1-.098-.183l-.981.195Zm.371.695c.19.19.432.319.695.371l.195-.98a.358.358 0 0 1-.182-.098l-.708.707Zm.695.371c.264.053.536.026.784-.077l-.382-.924a.357.357 0 0 1-.207.02l-.195.981Zm.784-.077c.248-.103.46-.277.61-.5l-.832-.555a.357.357 0 0 1-.16.131l.382.924Zm.61-.5c.149-.223.228-.485.228-.754h-1c0 .07-.02.14-.06.199l.832.555Zm.228-.76a1.369 1.369 0 0 0-.4-.95l-.708.707c.068.068.107.16.108.256l1-.013Zm-.4-.95a1.369 1.369 0 0 0-.95-.401l-.013 1c.096.001.187.04.255.108l.707-.707Z",
    fill: "#292929"
  })));
};

var _path$j;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 11.333 8.257 8.256M9.56 5.114a4.447 4.447 0 1 1-8.894 0 4.447 4.447 0 0 1 8.894 0Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$i;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "m5.85 3.232.37.652a.75.75 0 0 0 .33-.38l-.7-.272Zm.523-1.348.7.271-.7-.27Zm1.13-.777v-.75H7.5l.002.75Zm.995 0L8.5.357h-.002v.75Zm1.13.777-.7.27v.001l.7-.27Zm.521 1.348-.7.271a.75.75 0 0 0 .326.38l.374-.65Zm1.773 1.02-.374.65a.75.75 0 0 0 .487.092l-.113-.742Zm1.433-.218-.1-.744-.013.002.113.742Zm1.214.595.651-.373-.002-.003-.649.376Zm.486.85-.651.372.004.008.647-.38Zm-.097 1.372-.587-.468-.003.005.59.463ZM14.07 7.98l-.59-.463a.75.75 0 0 0-.16.463h.75Zm0 2.04h-.75a.75.75 0 0 0 .167.47l.583-.47Zm.911 1.13.587-.468-.003-.004-.584.471Zm.097 1.371-.646-.38-.005.008.651.373Zm-.485.85.649.376.002-.003-.651-.373Zm-1.215.595-.113.742.012.002.101-.744Zm-1.433-.218.114-.741a.75.75 0 0 0-.488.09l.374.65Zm-1.772 1.02-.374-.65a.75.75 0 0 0-.326.379l.7.27Zm-.523 1.348-.699-.271.7.27Zm-1.129.777v.75h.002l-.002-.75Zm-1.02 0-.002.75h.002v-.75Zm-1.13-.777.7-.27v-.001l-.7.27Zm-.521-1.348.7-.271a.75.75 0 0 0-.326-.38l-.374.65Zm-1.773-1.02.374-.65a.75.75 0 0 0-.487-.091l.113.74Zm-1.433.219.1.743.013-.002-.113-.742Zm-1.214-.596-.651.373.002.003.649-.376Zm-.486-.85.651-.372-.004-.008-.647.38Zm.097-1.372.587.468.003-.005-.59-.463Zm.887-1.129.59.463a.75.75 0 0 0 .16-.463h-.75Zm0-2.04h.75a.75.75 0 0 0-.167-.47l-.583.47Zm-.911-1.13-.587.468.003.004.584-.471ZM.92 5.48l.646.38.005-.008-.651-.372Zm.485-.85-.649-.376-.002.003.651.373Zm1.215-.595.113-.742-.012-.002-.101.744Zm1.433.218-.114.742a.75.75 0 0 0 .484-.09l-.37-.652ZM5.57 9h-.75.75Zm.98-5.497.521-1.348-1.399-.542-.522 1.348 1.4.542Zm.522-1.349a.464.464 0 0 1 .17-.215L6.393.703a1.964 1.964 0 0 0-.72.911l1.4.54Zm.17-.215a.464.464 0 0 1 .261-.082L7.5.357a1.964 1.964 0 0 0-1.108.346l.85 1.236Zm.26-.082h.995v-1.5h-.996v1.5Zm.993 0c.093 0 .184.029.261.082l.85-1.236A1.964 1.964 0 0 0 8.5.357l-.004 1.5Zm.261.082a.464.464 0 0 1 .17.215l1.4-.54a1.964 1.964 0 0 0-.72-.91l-.85 1.235Zm.17.216.523 1.348 1.399-.542-.523-1.348-1.398.542Zm.848 1.727 1.773 1.02.748-1.3-1.773-1.02-.748 1.3Zm2.26 1.112 1.433-.219-.226-1.483-1.433.219.226 1.483Zm1.42-.217a.464.464 0 0 1 .268.043l.66-1.347a1.964 1.964 0 0 0-1.129-.183l.202 1.487Zm.268.043c.082.04.151.105.197.184l1.298-.751a1.964 1.964 0 0 0-.835-.78l-.66 1.347Zm.195.18.486.85 1.302-.744-.486-.85-1.302.745Zm.49.859c.048.08.07.174.063.268l1.497.106a1.964 1.964 0 0 0-.267-1.135l-1.293.76Zm.063.268a.464.464 0 0 1-.1.256l1.173.935c.248-.31.396-.689.424-1.085l-1.497-.106Zm-.103.26-.886 1.13 1.18.926.886-1.13-1.18-.925ZM13.32 7.98v2.04h1.5V7.98h-1.5Zm.167 2.51.91 1.13 1.168-.941-.91-1.13-1.168.942Zm.908 1.127a.464.464 0 0 1 .1.256l1.496-.106a1.965 1.965 0 0 0-.423-1.085l-1.173.935Zm.1.256a.465.465 0 0 1-.063.268l1.293.76c.201-.342.294-.737.266-1.134l-1.496.106Zm-.068.276-.486.85 1.303.745.486-.85-1.303-.745Zm-.484.847a.464.464 0 0 1-.197.184l.66 1.347c.35-.171.64-.443.836-.78l-1.299-.751Zm-.197.184a.464.464 0 0 1-.267.043l-.202 1.487c.386.052.78-.012 1.129-.183l-.66-1.347Zm-.255.045-1.433-.218-.226 1.482 1.433.219.226-1.483Zm-1.92-.127L9.8 14.118l.748 1.3 1.772-1.02-.748-1.3Zm-2.098 1.399-.522 1.348 1.399.542.522-1.348-1.399-.542Zm-.522 1.349a.464.464 0 0 1-.17.215l.85 1.236c.326-.225.577-.542.72-.911l-1.4-.54Zm-.17.215a.465.465 0 0 1-.262.082l.004 1.5a1.965 1.965 0 0 0 1.108-.346l-.85-1.236Zm-.26.082h-1.02v1.5h1.02v-1.5Zm-1.018 0a.465.465 0 0 1-.261-.082l-.85 1.236c.325.224.711.345 1.107.346l.004-1.5Zm-.261-.082a.464.464 0 0 1-.17-.215l-1.4.54c.143.369.393.686.72.91l.85-1.235Zm-.17-.216-.523-1.348-1.399.542.522 1.348 1.4-.542Zm-.848-1.727-1.773-1.02-.748 1.3 1.773 1.02.748-1.3Zm-2.26-1.111-1.433.218.226 1.483 1.433-.219-.226-1.482Zm-1.42.216a.464.464 0 0 1-.268-.043l-.66 1.347c.35.171.743.235 1.129.183l-.202-1.487Zm-.268-.043a.465.465 0 0 1-.197-.184l-1.298.751c.195.337.486.609.835.78l.66-1.347ZM2.082 13l-.486-.85-1.302.744.486.85 1.302-.745Zm-.49-.859a.465.465 0 0 1-.063-.268l-1.497-.106c-.028.397.065.792.266 1.135l1.294-.76Zm-.063-.268a.464.464 0 0 1 .1-.256l-1.173-.935c-.248.31-.396.69-.424 1.085l1.497.106Zm.103-.26.887-1.13-1.18-.926-.887 1.13 1.18.925ZM2.68 10.02V7.98h-1.5v2.04h1.5Zm-.167-2.51-.91-1.13-1.168.942.91 1.129 1.168-.942Zm-.908-1.127a.464.464 0 0 1-.1-.256l-1.496.106c.028.396.176.774.423 1.085l1.173-.935Zm-.1-.256a.464.464 0 0 1 .063-.268l-1.293-.76a1.964 1.964 0 0 0-.266 1.134l1.496-.106Zm.068-.276L2.058 5 .755 4.256l-.485.85 1.302.745Zm.484-.847a.464.464 0 0 1 .197-.184l-.66-1.347c-.35.171-.64.443-.836.78l1.299.751Zm.197-.184a.464.464 0 0 1 .267-.043l.202-1.487a1.964 1.964 0 0 0-1.129.183l.66 1.347Zm.255-.045 1.432.219.227-1.483-1.433-.219-.226 1.483Zm1.916.13 1.797-1.02-.74-1.305L3.683 3.6l.74 1.304ZM4.82 9c0 .629.187 1.243.536 1.766l1.247-.833A1.679 1.679 0 0 1 6.321 9h-1.5Zm.536 1.766c.35.523.846.93 1.427 1.17l.574-1.385a1.678 1.678 0 0 1-.754-.618l-1.247.833Zm1.427 1.17c.58.241 1.22.304 1.836.181l-.293-1.47a1.678 1.678 0 0 1-.97-.096l-.573 1.386Zm1.836.181a3.179 3.179 0 0 0 1.628-.87l-1.061-1.06a1.678 1.678 0 0 1-.86.46l.293 1.47Zm1.628-.87a3.18 3.18 0 0 0 .87-1.627l-1.472-.292a1.679 1.679 0 0 1-.46.859l1.062 1.06Zm.87-1.627a3.179 3.179 0 0 0-.181-1.836l-1.386.574c.127.306.16.644.095.97l1.471.292Zm-.181-1.836a3.179 3.179 0 0 0-1.171-1.427l-.833 1.247c.276.185.49.447.618.754l1.386-.574ZM9.766 6.357A3.179 3.179 0 0 0 8 5.821v1.5c.332 0 .657.099.933.283l.833-1.247ZM8 5.821c-.843 0-1.652.335-2.248.931l1.061 1.061A1.679 1.679 0 0 1 8 7.321v-1.5Zm-2.248.931A3.179 3.179 0 0 0 4.822 9h1.5c0-.445.176-.872.491-1.187l-1.06-1.06Z",
    fill: "currentColor"
  })));
};

var _path$h;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "m11.7 1.557 2.271 4.586a.73.73 0 0 0 .586.428l5.014.743A.772.772 0 0 1 20 8.643l-3.614 3.586a.757.757 0 0 0-.229.685l.872 5.043a.785.785 0 0 1-1.143.829L11.37 16.4a.843.843 0 0 0-.742 0l-4.515 2.386a.787.787 0 0 1-1.143-.829l.872-5.1a.757.757 0 0 0-.229-.686L1.957 8.643a.771.771 0 0 1 .472-1.329l5.014-.743a.729.729 0 0 0 .586-.428L10.3 1.557a.771.771 0 0 1 1.4 0Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$g;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgTickets = function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M7.312 3.93a.75.75 0 0 0-.338-1.46l.338 1.46Zm-.726-.601-.169-.731a.75.75 0 0 0-.562.899l.73-.168Zm-1.3 2.042.154.734h.003l-.157-.734ZM3.229 4.057l.73-.168a.75.75 0 0 0-.881-.567l.15.735Zm-1.115.229-.15-.735-.01.002.16.733Zm-.871 1.428.733-.158a.75.75 0 0 0-.008-.035l-.725.193Zm.382 5.235a.75.75 0 1 0 1.464-.327l-1.464.327Zm16.232-7.763.286-.694a.75.75 0 0 0-.993.443l.707.25Zm-3.486-1.429.68.317a.75.75 0 0 0-.36-.996l-.32.68Zm-1.157-.543.319-.679a.747.747 0 0 0-.03-.013l-.289.692Zm-1.657.672-.689-.297-.001.003.69.294Zm-4.8 11.3.687.302.004-.01-.69-.292Zm-.628 1.428-.687-.302a.597.597 0 0 0-.006.014l.693.288Zm.671 1.657-.296.69h.002l.294-.69Zm5.8 2.472-.294.69.006.002.288-.692Zm1.657-.672.69.297v-.003l-.69-.294ZM19.686 5.3l.69.293.005-.013-.695-.28Zm-.614-1.614.333-.672a.727.727 0 0 0-.048-.022l-.285.694ZM6.973 2.469l-.557.129.337 1.461.558-.128-.338-1.462Zm-1.12 1.028a.95.95 0 0 1 .011.373l1.479.255a2.45 2.45 0 0 0-.027-.964l-1.462.336Zm.011.373a.95.95 0 0 1-.135.35l1.266.805a2.45 2.45 0 0 0 .348-.9L5.865 3.87Zm-.135.35a.95.95 0 0 1-.259.27l.857 1.23a2.45 2.45 0 0 0 .668-.695L5.73 4.219Zm-.259.27a.95.95 0 0 1-.343.148l.315 1.467a2.45 2.45 0 0 0 .885-.384l-.857-1.232Zm-.34.147a.993.993 0 0 1-.738-.134l-.808 1.264c.55.351 1.216.473 1.855.338l-.309-1.468Zm-.738-.134a.993.993 0 0 1-.433-.614l-1.462.336c.146.637.537 1.19 1.087 1.542l.808-1.264Zm-1.315-1.18-1.114.228.301 1.47 1.114-.23-.301-1.469Zm-1.123.23c-.252.055-.49.16-.7.31l.87 1.222a.407.407 0 0 1 .15-.067l-.32-1.465Zm-.7.31c-.21.15-.388.34-.522.56l1.28.781a.407.407 0 0 1 .112-.12l-.87-1.221Zm-.522.56c-.134.22-.223.465-.26.72l1.485.215a.407.407 0 0 1 .056-.154l-1.281-.78Zm-.26.72c-.036.255-.021.515.045.764l1.45-.386a.407.407 0 0 1-.01-.163L.474 5.143Zm.77.571-.733.158s0 0 0 0 0 0 0 0v.002l.001.005.005.021.017.08a513.683 513.683 0 0 0 .31 1.423c.203.933.482 2.202.782 3.546l1.464-.327A774.955 774.955 0 0 1 2 5.664l-.017-.08-.004-.021-.002-.005v-.001s0 0 0 0 0 0 0 0l-.733.157Zm15.907-2.78a1.135 1.135 0 0 1-.236.392l1.102 1.017c.242-.262.429-.57.548-.906l-1.414-.502Zm-.236.392c-.104.113-.23.203-.37.266l.612 1.37c.326-.146.618-.357.86-.619l-1.102-1.017Zm-.37.266c-.14.063-.292.096-.446.099l.024 1.5a2.636 2.636 0 0 0 1.034-.23l-.612-1.37Zm-.446.099a1.136 1.136 0 0 1-.449-.085l-.568 1.388c.33.135.684.202 1.04.196l-.023-1.5Zm-.449-.085a1.136 1.136 0 0 1-.378-.255L14.2 4.403c.25.255.55.456.88.59l.568-1.387Zm-.378-.255a1.135 1.135 0 0 1-.249-.383l-1.397.546c.13.333.326.635.576.89l1.07-1.053Zm-.249-.383a1.137 1.137 0 0 1-.077-.45l-1.5-.048c-.01.357.05.712.18 1.044l1.397-.546Zm-.077-.45c.005-.153.041-.304.106-.444l-1.359-.634a2.635 2.635 0 0 0-.246 1.03l1.499.048Zm-.255-1.44L13.533.535l-.637 1.358 1.157.543.637-1.358ZM13.503.522a2.021 2.021 0 0 0-1.537-.008l.564 1.39a.521.521 0 0 1 .396.003l.577-1.385ZM11.966.514c-.493.2-.888.587-1.098 1.075l1.378.593a.521.521 0 0 1 .284-.277l-.564-1.39Zm-1.099 1.078-4.8 11.3 1.38.587 4.8-11.3-1.38-.587ZM6.071 12.884l-.629 1.428 1.373.604.629-1.428-1.373-.604Zm-.635 1.442a2.021 2.021 0 0 0-.007 1.536l1.39-.563a.521.521 0 0 1 .002-.396l-1.385-.577Zm-.007 1.536c.2.494.586.888 1.075 1.098l.592-1.378a.521.521 0 0 1-.277-.283l-1.39.563Zm1.077 1.1 5.8 2.47.588-1.38-5.8-2.47-.588 1.38Zm5.806 2.473a2.02 2.02 0 0 0 1.536.008l-.563-1.39a.521.521 0 0 1-.396-.002l-.577 1.384Zm1.536.008c.493-.2.888-.586 1.098-1.075l-1.378-.593a.521.521 0 0 1-.283.277l.563 1.39Zm1.1-1.078 5.428-12.772-1.38-.586-5.429 12.771 1.38.587ZM20.38 5.58c.19-.472.196-.998.015-1.474l-1.402.533a.521.521 0 0 1-.004.38l1.392.561Zm.015-1.474a2.021 2.021 0 0 0-.991-1.092l-.667 1.344a.521.521 0 0 1 .256.281l1.402-.533Zm-1.039-1.114-1.214-.5-.571 1.387 1.214.5.571-1.387Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$f;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M13.143 7.286 12 16.429H4L2.857 7.286M1.143 5h13.714m-9.76-.331V2.69A1.143 1.143 0 0 1 6.24 1.55h3.429A1.143 1.143 0 0 1 10.81 2.69v2.286",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$e;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M9.357 16.573H1.643v-.697A5.798 5.798 0 0 1 10 10.733m4.5-.588v7.714m-3.857-3.857h7.714M7.428 7.573a3.214 3.214 0 1 0 0-6.429 3.214 3.214 0 0 0 0 6.43Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$d;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgUserChecked = function SvgUserChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M6.714 15.286H1.571v-.62a5.155 5.155 0 0 1 5.376-5.094 5.154 5.154 0 0 1 3.6 1.714m5.881-1.143-4.708 6.286-3.143-2.355M6.714 7.286a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$c;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgUserDelete = function SvgUserDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M10.643 16.573h-9v-.697a5.798 5.798 0 0 1 6.047-5.731c.836.04 1.652.26 2.392.642m8.275 1.62-5.452 5.452m0-5.452 5.452 5.452M7.428 7.573a3.214 3.214 0 1 0 0-6.429 3.214 3.214 0 0 0 0 6.43Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$b;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgUserEdit = function SvgUserEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M6.929 19.607a.75.75 0 0 0 0-1.5v1.5Zm-5.715-.75h-.75c0 .414.336.75.75.75v-.75Zm0-.774-.75-.008v.008h.75Zm.835-3.105-.653-.37.653.37Zm2.231-2.315.393.639-.393-.64Zm3.072-.949-.035-.749.035.75Zm.29-.007.002-.75h-.003l.002.75Zm.292.007.035-.749-.035.75Zm2.313 1.38a.75.75 0 1 0 .69-1.331l-.69 1.332Zm9.539.049.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-6.729 6.729.101.743a.75.75 0 0 0 .43-.213l-.53-.53Zm-3.043.414-.742-.105a.75.75 0 0 0 .843.848l-.1-.743Zm.429-3.043-.531-.53a.75.75 0 0 0-.212.425l.743.105Zm6.714-6.729.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-9.514-.907a4.321 4.321 0 0 0 4.321-4.321h-1.5a2.821 2.821 0 0 1-2.821 2.821v1.5Zm4.321-4.321A4.321 4.321 0 0 0 7.643.964v1.5a2.821 2.821 0 0 1 2.821 2.822h1.5ZM7.643.964A4.321 4.321 0 0 0 3.32 5.286h1.5a2.821 2.821 0 0 1 2.822-2.822v-1.5ZM3.32 5.286a4.321 4.321 0 0 0 4.322 4.321v-1.5A2.821 2.821 0 0 1 4.82 5.286h-1.5ZM6.93 18.107H1.214v1.5H6.93v-1.5Zm-4.965.75v-.774h-1.5v.774h1.5Zm0-.766c.01-.963.264-1.907.738-2.744l-1.306-.739a7.193 7.193 0 0 0-.932 3.467l1.5.016Zm.738-2.744a5.693 5.693 0 0 1 1.971-2.045l-.786-1.278a7.194 7.194 0 0 0-2.49 2.585l1.305.738Zm1.971-2.045a5.693 5.693 0 0 1 2.715-.838l-.071-1.499a7.193 7.193 0 0 0-3.43 1.06l.786 1.277Zm2.715-.838c.085-.005.171-.007.256-.007l-.003-1.5c-.108 0-.216.003-.324.008l.07 1.498Zm.253-.007c.086 0 .171.002.257.006l.071-1.498a7.175 7.175 0 0 0-.325-.008l-.003 1.5Zm.257.006c.82.04 1.622.255 2.349.632l.69-1.332a7.193 7.193 0 0 0-2.968-.798l-.07 1.498Zm11.357.15-6.728 6.728 1.06 1.06 6.729-6.728-1.06-1.06Zm-6.3 6.515-3.042.415.202 1.486 3.043-.414-.202-1.487Zm-2.198 1.262.428-3.043-1.485-.209-.428 3.043 1.485.21Zm.217-2.617 6.714-6.729-1.062-1.06-6.714 6.73 1.062 1.059Zm5.653-6.728 2.628 2.628 1.061-1.06-2.628-2.629-1.061 1.06Z",
    fill: "currentColor"
  })));
};

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgUserLock = function SvgUserLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M8.357 19.607a.75.75 0 0 0 0-1.5v1.5Zm-7.143-.75h-.75c0 .414.336.75.75.75v-.75Zm0-.774-.75-.008v.008h.75Zm.835-3.105-.653-.37.653.37Zm2.231-2.315.393.639-.393-.64Zm3.072-.949-.035-.749.035.75Zm.29-.007.002-.75h-.003l.002.75Zm.292.007.035-.749-.035.75Zm.97.888a.75.75 0 1 0 .335-1.462l-.336 1.462Zm2.989 1.255a.75.75 0 0 0 1.5 0h-1.5Zm1.587-3.449.53.53-.53-.53Zm4.04 0-.53.53.53-.53Zm.087 3.45a.75.75 0 0 0 1.5 0h-1.5Zm-9.964-4.25a4.321 4.321 0 0 0 4.321-4.322h-1.5a2.821 2.821 0 0 1-2.821 2.821v1.5Zm4.321-4.322A4.321 4.321 0 0 0 7.643.964v1.5a2.821 2.821 0 0 1 2.821 2.822h1.5ZM7.643.964A4.321 4.321 0 0 0 3.32 5.286h1.5a2.821 2.821 0 0 1 2.822-2.822v-1.5ZM3.32 5.286a4.321 4.321 0 0 0 4.322 4.321v-1.5A2.821 2.821 0 0 1 4.82 5.286h-1.5Zm5.036 12.821H1.214v1.5h7.143v-1.5Zm-6.393.75v-.774h-1.5v.774h1.5Zm0-.766c.01-.963.264-1.907.738-2.744l-1.306-.739a7.193 7.193 0 0 0-.932 3.467l1.5.016Zm.738-2.744a5.693 5.693 0 0 1 1.971-2.045l-.786-1.278a7.193 7.193 0 0 0-2.49 2.585l1.305.738Zm1.971-2.045a5.693 5.693 0 0 1 2.715-.838l-.071-1.499a7.192 7.192 0 0 0-3.43 1.06l.786 1.277Zm2.715-.838c.085-.005.171-.007.256-.007l-.003-1.5c-.108 0-.216.003-.324.008l.07 1.498Zm.253-.007c.086 0 .171.002.257.006l.071-1.498a7.175 7.175 0 0 0-.325-.008l-.003 1.5Zm.257.006c.34.017.676.063 1.005.139l.336-1.462a7.193 7.193 0 0 0-1.27-.175l-.07 1.498Zm11.173.644h-7.143v1.5h7.143v-1.5Zm-7.143 0c-.808 0-1.464.656-1.464 1.465h1.5c0 .02-.016.035-.036.035v-1.5Zm-1.464 1.465v5h1.5v-5h-1.5Zm0 5c0 .808.656 1.464 1.464 1.464v-1.5c.02 0 .036.016.036.035h-1.5Zm1.464 1.464h7.143v-1.5h-7.143v1.5Zm7.143 0c.81 0 1.465-.656 1.465-1.465h-1.5c0-.02.016-.035.035-.035v1.5Zm1.465-1.465v-5h-1.5v5h1.5Zm0-5c0-.808-.656-1.464-1.465-1.464v1.5a.036.036 0 0 1-.035-.035h1.5Zm-7.143-.714V12.43h-1.5v1.428h1.5Zm0-1.428c0-.56.222-1.095.617-1.49l-1.06-1.061a3.607 3.607 0 0 0-1.057 2.55h1.5Zm.617-1.49a2.107 2.107 0 0 1 1.49-.617v-1.5c-.957 0-1.874.38-2.55 1.056l1.06 1.06Zm1.49-.617c.559 0 1.095.221 1.49.617l1.06-1.061a3.607 3.607 0 0 0-2.55-1.057v1.5Zm1.49.617c.395.395.617.93.617 1.49h1.5c0-.957-.38-1.875-1.056-2.551l-1.061 1.06Zm.617 1.49v1.428h1.5V12.43h-1.5Z",
    fill: "currentColor"
  })));
};

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgUserOffice = function SvgUserOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "m19.786 10.914-.75-.005v.005h.75Zm-.458-1.057.51-.55-.001-.001-.509.551ZM10.5 1.714l.508-.551L10.5.694l-.509.469.509.551ZM1.671 9.857l-.508-.551-.002.001.51.55Zm-.457 1.057h.75v-.005l-.75.005Zm.419 8.953-.53.53.53-.53Zm18.903-8.948a2.181 2.181 0 0 0-.18-.88l-1.376.596c.037.087.056.18.056.274l1.5.01Zm-.18-.88a2.178 2.178 0 0 0-.518-.732l-1.02 1.1a.677.677 0 0 1 .162.228l1.377-.595Zm-.519-.733-8.829-8.143-1.017 1.103 8.829 8.143 1.017-1.103ZM9.991 1.163 1.163 9.306l1.017 1.103 8.829-8.143L9.99 1.163Zm-8.83 8.144a2.179 2.179 0 0 0-.518.733l1.377.595a.679.679 0 0 1 .161-.228l-1.02-1.1Zm-.518.733c-.12.278-.18.577-.179.88l1.5-.01c0-.095.019-.188.056-.275L.643 10.04Zm-.179.874v7.943h1.5v-7.943h-1.5Zm0 7.943c0 .578.23 1.132.638 1.54l1.06-1.06a.678.678 0 0 1-.198-.48h-1.5Zm.638 1.54c.409.41.963.639 1.54.639v-1.5a.679.679 0 0 1-.479-.2l-1.06 1.062Zm1.54.639h15.715v-1.5H2.643v1.5Zm15.715 0c.578 0 1.132-.23 1.54-.638l-1.06-1.061a.679.679 0 0 1-.48.199v1.5Zm1.54-.638c.41-.409.639-.963.639-1.54h-1.5c0 .18-.072.352-.2.479l1.062 1.06Zm.639-1.54v-7.944h-1.5v7.943h1.5Zm-7.927-8.875A2.109 2.109 0 0 1 10.5 12.09v1.5a3.609 3.609 0 0 0 3.609-3.608h-1.5ZM10.5 12.09a2.109 2.109 0 0 1-2.109-2.108h-1.5A3.609 3.609 0 0 0 10.5 13.59v-1.5ZM8.391 9.983c0-1.165.944-2.109 2.109-2.109v-1.5a3.609 3.609 0 0 0-3.609 3.609h1.5ZM10.5 7.874c1.165 0 2.109.944 2.109 2.109h1.5A3.609 3.609 0 0 0 10.5 6.374v1.5ZM5.312 20.41a5.263 5.263 0 0 1 5.188-4.38v-1.5a6.763 6.763 0 0 0-6.667 5.631l1.479.25Zm5.188-4.38a5.264 5.264 0 0 1 5.188 4.38l1.48-.249a6.764 6.764 0 0 0-6.668-5.63v1.5Z",
    fill: "currentColor"
  })));
};

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgUserSharedSpace = function SvgUserSharedSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.429 15.217a7.696 7.696 0 0 1 7.714 7.714m-10.286 0H2.571L.857 14.36h10.286l1.714 8.571Zm0 0H18M1.149 3.08a6.857 6.857 0 0 1 9.703 0m-6.67 3.034a2.554 2.554 0 0 1 3.635 0m7.612 5.675a3.429 3.429 0 1 0 0-6.858 3.429 3.429 0 0 0 0 6.858Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgViewOff = function SvgViewOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.429 15.49a6.648 6.648 0 0 1-1.929.296c-3.587 0-6.66-3.182-8.01-4.817A1.553 1.553 0 0 1 1.159 10c0-.358.118-.703.331-.97a19.214 19.214 0 0 1 1.764-1.868m8.064 4.656a2.571 2.571 0 1 0-3.636-3.636m10.175 10.175L1.143 1.643M5.166 5.66C6.442 4.83 7.921 4.214 9.5 4.214c3.587 0 6.66 3.182 8.01 4.817.213.266.331.611.331.97 0 .357-.118.702-.331.968-.744.901-2.012 2.272-3.6 3.322L5.165 5.66Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$6, _path2$1;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgViewOn = function SvgViewOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 8.031c.213.266.331.611.331.97 0 .357-.118.702-.331.968-1.35 1.635-4.423 4.817-8.01 4.817-3.587 0-6.66-3.182-8.01-4.817A1.553 1.553 0 0 1 1.659 9c0-.358.118-.703.331-.969C3.34 6.396 6.413 3.214 10 3.214c3.587 0 6.66 3.182 8.01 4.817Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.571a2.571 2.571 0 1 0 0-5.142 2.571 2.571 0 0 0 0 5.142Z",
    stroke: "currentColor",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$5, _path2, _path3;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgDoor = function SvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 1.563h9.75a.75.75 0 0 1 .75.75v16.125H3.375V2.313a.75.75 0 0 1 .75-.75Z",
    stroke: "#292929",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 18.438h15.75",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 10.281a.281.281 0 1 1 0-.562M11.813 10.281a.281.281 0 1 0 0-.562",
    stroke: "#000",
    strokeWidth: 1.5
  })));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.571 14.457-1.257 5.286a.729.729 0 0 1-.371.471.773.773 0 0 1-.615 0l-4.742-2.071a.728.728 0 0 1-.258-1.114L5 12.429m6.428 1.957 1.286 5.357a.714.714 0 0 0 .386.471.729.729 0 0 0 .6 0l4.714-2.071a.714.714 0 0 0 .4-.5.686.686 0 0 0-.143-.614l-3.828-4.872m1.4-4.014a6.429 6.429 0 1 1-12.857 0 6.429 6.429 0 0 1 12.857 0Zm-3.572 0a2.857 2.857 0 1 1-5.714 0 2.857 2.857 0 0 1 5.714 0Z",
    stroke: "#292929",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgOrderTable = function SvgOrderTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.595 13.775-2.653 2.653m0 0-2.653-2.653m2.653 2.653V1.571m-3.714 0H.738m8.49 3.184H3.39m5.837 3.183H6.044",
    stroke: "#292929",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgFindOffices = function SvgFindOffices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13 7.756A5.29 5.29 0 0 0 7.756 13 6.05 6.05 0 0 0 13 7.756ZM1 6.244A5.291 5.291 0 0 0 6.244 1 6.05 6.05 0 0 0 1 6.244ZM7.756 1A6.05 6.05 0 0 1 13 6.244 5.291 5.291 0 0 1 7.756 1ZM6.244 13A5.291 5.291 0 0 0 1 7.756 6.05 6.05 0 0 0 6.244 13ZM7 9.927A6.833 6.833 0 0 0 4.073 7 6.833 6.833 0 0 0 7 4.073 6.833 6.833 0 0 0 9.927 7 6.833 6.833 0 0 0 7 9.927Z",
    stroke: "#7A7A7A"
  })));
};

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgPackages = function SvgPackages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H2.75A1.276 1.276 0 0 0 1.5 9.3v3.9a1.276 1.276 0 0 0 1.25 1.3h5A1.275 1.275 0 0 0 9 13.2M9 8v5.2M9 8h6.25a1.275 1.275 0 0 1 1.25 1.3v3.9a1.276 1.276 0 0 1-1.25 1.3h-5A1.276 1.276 0 0 1 9 13.2M12.5 8V2.8a1.275 1.275 0 0 0-1.25-1.3h-5A1.276 1.276 0 0 0 5 2.8V8M4 8h2.5v3.5H4V8Zm3.5-6.5H10V5H7.5V1.5Zm4 6.5H14v3.5h-2.5V8Z",
    stroke: "#292929",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.552 8.452a4.582 4.582 0 0 0 3.348 1.836c3.3 0 5.363-3.573 3.713-6.431A4.287 4.287 0 0 0 15.9 1.713C12.837 1.713 11 6 11 6s-1.837 4.288-4.9 4.288c-3.3 0-5.363-3.573-3.713-6.431A4.288 4.288 0 0 1 6.1 1.713a4.587 4.587 0 0 1 3.348 1.84",
    stroke: "#292929",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgAlertCircle as AlertCircleIcon, SvgAlert as AlertIcon, SvgArrowLeft as ArrowLeft, SvgBellAlert as BellAlert, SvgBulletList as BulletListIcon, SvgCalendar as CalendarIcon, SvgCancel as CancelIcon, SvgChair as ChairIcon, SvgChampagneIcon as ChampagneIcon, SvgCheckCircle as CheckCircleIcon, SvgCheck as CheckIcon, SvgChevronDown as ChevronDownIcon, SvgChevronLeft as ChevronLeft, SvgChevronRight as ChevronRight, SvgClockCircle as ClockCircleIcon, SvgClockCircleReturn as ClockCircleReturnIcon, SvgClose as CloseIcon, SvgCloseOutlined as CloseOutlinedIcon, SvgCsvDownload as CsvDownloadIcon, SvgDoor as DoorIcon, SvgExit as ExitIcon, SvgExport as ExportIcon, SvgFile as FileIcon, SvgFilter as FilterIcon, SvgFindOffices as FindOfficesIcon, SvgFriendship as FriendshipIcon, SvgGridView as GridViewIcon, SvgGroup as GroupIcon, SvgHome as HomeIcon, SvgInfinity as InfinityIcon, SvgInfoFilled as InfoFilledIcon, SvgInfo as InfoIcon, SvgInvoice as InvoiceIcon, SvgLocationCompany as LocationCompanyIcon, SvgLocationPin as LocationPinIcon, SvgMailFlash as MailFlashIcon, SvgMailSendEnvelope as MailSendEnvelopeIcon, SvgMap as MapIcon, SvgMapLocationStar as MapStarLocationIcon, SvgMedal as MedalIcon, SvgMinus as MinusIcon, SvgMoneyCircle as MoneyCircleIcon, SvgMoneyNote as MoneyNote, SvgNavigation as NavigationIcon, SvgOrderTable as OrderTableIcon, SvgPackages as PackagesIcon, SvgPencilEditor as PencilIcon, SvgPlus as PlusIcon, SvgQuestion as QuestionIcon, SvgSearch as SearchIcon, SvgSettings as SettingsIcon, SvgStar as StarIcon, SvgTickets as TicketsIcon, SvgTrash as TrashIcon, SvgUserAdd as UserAddIcon, SvgUserChecked as UserCheckedIcon, SvgUserDelete as UserDeleteIcon, SvgUserEdit as UserEditIcon, SvgUserLock as UserLockIcon, SvgUserOffice as UserOfficeIcon, SvgUserSharedSpace as UserSharedSpaceIcon, SvgViewOff as ViewOffIcon, SvgViewOn as ViewOnIcon };
